import Vue from "vue";
import Router from "vue-router";

// Vuex Store
import store from "../store/store";
import axios from "axios";

import adminRoute from "@/router/adminRoute";
import userRoute from "@/router/userRoute";
import fullPagesRoute from "@/router/fullPagesRoute";

// NProgress
import NProgress from "nprogress";
import facultyAPI from "@/api/facultyAPI";

Vue.use(Router);

const index = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    adminRoute,
    userRoute,
    fullPagesRoute,
    {
      // Redirect to 404 page, if no match found
      path: "*",
      redirect: "/not-found-404",
    },
  ],
});

index.beforeEach(async (to, from, next) => {
  NProgress.configure({ speed: 3000 });
  NProgress.set(0.7);
  NProgress.configure({ speed: 200 });

  if (!store.state.facultyInfo.id) {
    await facultyAPI
      .info()
      .then(({ data }) => {
        store.commit("SET_FACULTY_INFO", data);
      })
      .catch((error) => {
        if (error.status === 404)
          window.location.replace("https://classhub.ly");
      });
  }

  if (!store.state.date) {
    await axios
      .create({ withCredentials: false })
      .get("https://api.classhub.ly/api/get-time")
      .then(({ data }) => store.dispatch("timer", data.datetime))
      .catch(() => store.dispatch("timer", new Date()));
  }

  let role = to.meta.role;
  if (!role) return next();

  await store.dispatch("auth/validate").then((valid) => {
    if (valid) {
      if (!store.getters["auth/hasRole"](role)) {
        !store.getters["auth/hasRole"](["admin"]) ? next("/") : next("/admin");
      }
    } else {
      next("/login");
    }
  });

  if (
    store.state["auth"].loggedIn &&
    store.getters["auth/hasRole"](["teacher", "student"])
  ) {
    await store.dispatch(`courses/load_courses`);
  }

  next();
});

index.afterEach((to) => {
  NProgress.done();
  document.title = to.meta.pageTitle
    ? to.meta.pageTitle + " - Classhub"
    : "Classhub";
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default index;
